import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.black,
    minHeight: '5em',
    color: 'white'
  }
}))